import {
  ACTIVE_STORE_ID_NAME,
  ASSIGNED_STORES_NAME,
  AUTH_TOKEN_NAME,
  REFRESH_TOKEN_NAME,
  USER_ACCESS,
  USER_OBJECT_NAME,
} from "../config/consts";
import Storage from "./storage.service";

export default class Auth {
  static set token(token) {
    Storage.token = token;
    if (token) {
      Storage.setItem(AUTH_TOKEN_NAME, token);
    } else {
      Storage.remove(AUTH_TOKEN_NAME);
    }
  }

  static get token() {
    return Storage.token || Storage.getItem(AUTH_TOKEN_NAME);
  }

  static set refreshToken(token) {
    if (token) {
      Storage.setItem(REFRESH_TOKEN_NAME, token);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_NAME);
    }
  }

  static get refreshToken() {
    return Storage.getItem(REFRESH_TOKEN_NAME);
  }

  static logout() {
    Storage.remove(USER_OBJECT_NAME);
    Storage.remove(AUTH_TOKEN_NAME);
    Storage.remove(USER_ACCESS);
    Storage.remove(ACTIVE_STORE_ID_NAME);
    Storage.remove(ASSIGNED_STORES_NAME);
    localStorage.removeItem(REFRESH_TOKEN_NAME);
    localStorage.removeItem(AUTH_TOKEN_NAME);
    localStorage.removeItem(ACTIVE_STORE_ID_NAME);
    localStorage.removeItem(ASSIGNED_STORES_NAME);
  }

  static set activeStoreId(storeId) {
    if (storeId == null || storeId === "") {
      Storage.remove(ACTIVE_STORE_ID_NAME);
      localStorage.removeItem(ACTIVE_STORE_ID_NAME);
    } else {
      Storage.setItem(ACTIVE_STORE_ID_NAME, String(storeId));
    }
  }

  static get activeStoreId() {
    const v = Storage.getItem(ACTIVE_STORE_ID_NAME);
    if (v == null || v === "") return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  static set assignedStores(stores) {
    if (!Array.isArray(stores) || stores.length === 0) {
      Storage.remove(ASSIGNED_STORES_NAME);
      localStorage.removeItem(ASSIGNED_STORES_NAME);
    } else {
      Storage.setObject(ASSIGNED_STORES_NAME, stores);
    }
  }

  static get assignedStores() {
    const v = Storage.getObject(ASSIGNED_STORES_NAME);
    return Array.isArray(v) ? v : [];
  }

  static set user(user) {
    Storage.setObject(USER_OBJECT_NAME, user);
  }

  static get user() {
    return Storage.getObject(USER_OBJECT_NAME);
  }

  static set userPermission(permissionArr) {
    Storage.setObject(USER_ACCESS, permissionArr);
  }

  static get userPermission() {
    const v = Storage.getObject(USER_ACCESS);
    return Array.isArray(v) ? v : [];
  }

  static get check() {
    const { token } = this;
    const { user } = this;
    return !(!token || !user);
  }
}
